/*
 * The countdown on the weekly reward ladder.
 *
 * Only presentation: the server decides when a week actually ends, and a browser left open
 * past the turnover simply shows zero until the next Livewire round trip replaces the panel.
 * Nothing here is allowed to decide that somebody has run out of time.
 */

document.addEventListener('alpine:init', () => {

	Alpine.data('forumRewardCountdown', (endsAt) => {

		/*
		 * The timer handle lives in the closure rather than on the returned object. Anything
		 * placed on that object is wrapped in Alpine's reactive proxy, and native handles do
		 * not survive that intact.
		 */
		let timer = null;

		return {

			remaining: '',

			init() {

				this.tick();

				timer = setInterval(() => this.tick(), 1000);
			},

			destroy() {
				clearInterval(timer);
				timer = null;
			},

			tick() {

				const seconds = Math.floor((endsAt * 1000 - Date.now()) / 1000);

				if (seconds <= 0) {
					this.remaining = 'any moment now';

					return;
				}

				const days = Math.floor(seconds / 86400);
				const hours = Math.floor((seconds % 86400) / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);

				/*
				 * Seconds are only shown in the last hour. Past that they are noise, and a
				 * figure that changes every second reads as urgent when it is not.
				 */
				if (days > 0) {
					this.remaining = `${days}d ${hours}h`;

					return;
				}

				if (hours > 0) {
					this.remaining = `${hours}h ${minutes}m`;

					return;
				}

				this.remaining = `${minutes}m ${seconds % 60}s`;
			},

		};

	});

});
